<div
  (focusin)="onContainerFocusIn()"
  (focusout)="onContainerFocusOut($event)"
  class="date-input-form-control">
  <div class="date-input-form-control__input-wrapper">
    <input
      #dayInput
      numericOnly
      (blur)="onDayBlur()"
      (focus)="onDayFocus()"
      (input)="onDayInput($event)"
      (keydown)="onDayKeydown($event)"
      [disabled]="disabled()"
      [readonly]="readonly()"
      [value]="dayNumber() ?? ''"
      max="31"
      min="1"
      placeholder="DD"
      type="number"
      class="date-input-form-control__hidden-input" />
    <span
      (click)="focusDayInput()"
      [class.disabled]="disabled()"
      [class.focused]="dayFocused()"
      [class.placeholder]="!dayText()"
      class="date-input-form-control__visible-text"
      >{{ dayText() || 'DD' }}</span
    >
  </div>
  <span
    [class.disabled]="disabled()"
    [class.placeholder]="!monthText() || !yearText() || !dayText()"
    class="date-input-form-control__separator"
    >/</span
  >

  <div class="date-input-form-control__input-wrapper">
    <input
      #monthInput
      numericOnly
      (blur)="onMonthBlur()"
      (focus)="onMonthFocus()"
      (input)="onMonthInput($event)"
      (keydown)="onMonthKeydown($event)"
      [disabled]="disabled()"
      [readonly]="readonly()"
      [value]="monthNumber() ?? ''"
      max="12"
      min="1"
      placeholder="MM"
      type="number"
      class="date-input-form-control__hidden-input" />
    <span
      (click)="focusMonthInput()"
      [class.disabled]="disabled()"
      [class.focused]="monthFocused()"
      [class.placeholder]="!monthText()"
      class="date-input-form-control__visible-text">
      {{ monthText() || 'MM' }}
    </span>
  </div>

  <span
    [class.disabled]="disabled()"
    [class.placeholder]="!monthText() || !yearText() || !dayText()"
    class="date-input-form-control__separator"
    >/</span
  >

  <div class="date-input-form-control__input-wrapper">
    <input
      #yearInput
      numericOnly
      (blur)="onYearBlur()"
      (focus)="onYearFocus()"
      (input)="onYearInput($event)"
      [disabled]="disabled()"
      [readonly]="readonly()"
      [value]="yearNumber() ?? ''"
      placeholder="AAAA"
      type="number"
      class="date-input-form-control__hidden-input" />
    <span
      (click)="focusYearInput()"
      [class.disabled]="disabled()"
      [class.focused]="yearFocused()"
      [class.placeholder]="!yearText()"
      class="date-input-form-control__visible-text">
      {{ yearText() || 'AAAA' }}
    </span>
  </div>
</div>
